<svg height="100%" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M29.1631 8.51057C28.3773 8.24878 27.7512 7.6227 27.4894 6.83693C26.1659 2.86428 22.4174 0 18 0C13.5826 0 9.83413 2.86428 8.51057 6.83693C8.24878 7.6227 7.6227 8.24878 6.83693 8.51057C2.86427 9.83413 0 13.5826 0 18C0 22.4174 2.86428 26.1659 6.83693 27.4894C7.6227 27.7512 8.24878 28.3773 8.51057 29.1631C9.83413 33.1357 13.5826 36 18 36C22.4174 36 26.1659 33.1357 27.4894 29.1631C27.7512 28.3773 28.3773 27.7512 29.1631 27.4894C33.1357 26.1659 36 22.4174 36 18C36 13.5826 33.1357 9.83413 29.1631 8.51057Z"
    class="background"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18 11.9395L24.0607 18.0001L18 24.0608L16.9393 23.0001L21.1893 18.7501H12.25V17.2501H21.1893L16.9393 13.0001L18 11.9395Z"
    class="foreground"
  />
</svg>
